import React from "react";

export interface ProjectLockDialogShowerContextProps {
    showLockDialog: boolean;
    setShowLockDialog: (showLockDialog: boolean) => void;
}

export const ProjectLockDialogShowerContext = React.createContext<ProjectLockDialogShowerContextProps | undefined>(undefined);